export enum ErrorCode {
    InsufficientWalletBalance = 1300
}

export const customErrorKeyword = ['pcs'];